import { ReactNode } from 'react';
import { Formik } from 'formik';

import { getValidationSchema } from '../../../utils/common/yupSchema';
import { ToolCategory } from '../../../utils/common/types';
import useSubmit from '../../../utils/hooks/useSubmit';
import useStore from '../../../services/store';

type FormProps = {
  children: ReactNode;
  category: ToolCategory;
};

function Form({ children, category }: FormProps) {
  const handleSubmit = useSubmit(category);
  const initialValues = useStore((state) => state.formValues);

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values, { setSubmitting }) => {
        handleSubmit(values, setSubmitting);
      }}
      validationSchema={getValidationSchema(category)}
    >
      {children}
    </Formik>
  );
}

export default Form;
